module.exports = __webpack_public_path__ + "images/category_lp/watch/assessment_achievements/6_6433369289512f27262056d45855c4c6.png";